import { Component } from '@angular/core';
import { OktaAuthTokenService } from '@referrals/core/services';

@Component({
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss'],
})
export class AdminLayoutComponent {
  constructor(public oktaAuth: OktaAuthTokenService) {}

  logout() {
    this.oktaAuth.signOut();
  }
}
